import React, { useEffect, useState } from "react";
import "./styles.scss";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { CreateNewAdvertisement } from "../CreateNewItem";
import { AdvCampaignCard, Button, DropBox, FormHeader } from "../../components";
import "./styles.scss";
import Scrollbars from "react-custom-scrollbars-2";
import { useDispatch, useSelector } from "react-redux";
import { setCampaign, setCampaignList } from "./redux/actions";
import {
  deleteAdvertisement,
  getAllAdvertisement,
  updateAdvertisementStatus,
} from "../CreateNewItem/CreateNewAdvertisement/service/advertisement.service";
import moment from "moment";

const Advertisement = () => {
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [formData, setFormData] = useState({
    category: {
      key: "category",
      label: "",
      size: "lg",
      placeholder: "select category",
      mainLayerStyles: " flex-column " + " align-content-center ",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const [selectCampaign, setSelectCampaign] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const campaignList = useSelector(
    (state) => state.advertismentReducer.campaignList
  );

  const dispatch = useDispatch();

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const onClickRefresh = async () => {
    setIsLoading(true);
    try {
      const getList = await getAllAdvertisement();
      console.log("Get All Campaign : ", getList);
      if (getList.data) {
        dispatch(setCampaignList(getList.data));
        setIsLoading(false);
      } else {
        console.log("Data Not Found");
      }
    } catch (error) {
      console.log("Error Refreshing Page", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const getList = await getAllAdvertisement();
        console.log("Get All Campaign : ", getList);

        if (getList.data) {
          dispatch(setCampaignList(getList.data));
        } else {
          console.log("Data Not Found");
        }
      } catch (error) {
        console.log("Error fetching Campaign Data", error);
      }
    };
    fetchData();
  }, []);

  const onChangeRefresh = (refresh) => {
    if (refresh) {
      setIsLoading(true);
      onClickRefresh();
    }
  };

  //get days
  const getActiveDayLabel = (schedule) => {
    if (!schedule) return "N/A";

    if (schedule.sevenDays) return "7";
    if (schedule.thirtyDays) return "30";
    if (schedule.oneTwentyEightDays) return "128";

    return "N/A";
  };

  const updateForm = { ...formData };

  return (
    <>
      <div className={"hne-advertisement-wrapper"}>
        <div className={"col-7 advertisement-body-wrapper"}>
          <div className={"d-flex flex-row justify-content-between"}>
            <FormHeader
              data={{
                formHeader: "Advertisement",
                size: "md-md",
              }}
            />
          </div>

          <div className={"hne-action-wrapper"}>
            <div className={"hne-aw-input-wrapper"}>
              <div style={{ minWidth: "205px" }}>
                <DropBox
                  data={updateForm.category}
                  onChange={(e) => {
                    const updateForm = { ...formData };
                    updateForm["category"].value = e;
                    setFormData(updateForm);
                    // dispatch(setCategoryDetails(e));
                  }}
                />
              </div>
            </div>
            <div className={"hne-aw-action-wrapper"}>
              <Button
                data={{
                  btnName: "REFRESH",
                  buttonType: "border",
                  buttonSize: "sm x",
                  isLoading: isLoading,
                }}
                onClick={async (e) => {
                  e.preventDefault();
                  await onClickRefresh(e);
                }}
              />
              <Button
                data={{
                  btnName: "SEARCH",
                  buttonType: "primary",
                  buttonSize: "sm x",
                  isLoading: false,
                }}
                // onClick={async (e) => {
                //   e.preventDefault();
                //   await onClickSave(e);
                // }}
              />
            </div>
          </div>
          <div className={"hne-ad-new-body-wrapper"}>
            <Scrollbars
              onScroll={handleOnScroll}
              renderView={(props) => (
                <div
                  {...props}
                  style={{ ...props.style, overflowX: "hidden" }}
                />
              )}
              style={{ height: viewPointHeight - 230 }}
            >
              <div className={"hne_ad-campaign-wrapper col-4"}>
                {Array.isArray(campaignList) && campaignList.length > 0 ? (
                  campaignList.map((campaign) => (
                    <AdvCampaignCard
                      isSelect={selectCampaign === campaign?.advertisement_id}
                      name={campaign.campaignName}
                      days={getActiveDayLabel(campaign.time_schedule)}
                      views={campaign?.view_count || 0}
                      clicks={campaign?.clicks || 0}
                      status={campaign.status}
                      expDate={
                        campaign?.end_date
                          ? moment(campaign?.end_date).format(
                              "MMMM Do YYYY, h:mm:ss a"
                            )
                          : moment().format("DD MMMM YYYY")
                      }
                      edit="Edit"
                      onClick={() => {
                        setSelectCampaign(campaign?.advertisement_id);
                        dispatch(setCampaign(campaign));
                      }}
                      onClickDeactivate={async (e) => {
                        try {
                          let result = await updateAdvertisementStatus(
                            { status: "deactivated" },
                            campaign?.advertisement_id
                          );
                          if (result?.data?.status) {
                            await onClickRefresh(e);
                          }
                        } catch (e) {
                          console.log("Error fetching Campaign Data", e);
                        }
                      }}
                      onClickDelete={async (e) => {
                        try {
                          let result = await deleteAdvertisement(
                            campaign?.advertisement_id
                          );
                          if (result?.data?.status) {
                            await onClickRefresh(e);
                          }
                        } catch (e) {
                          console.log("Error fetching Campaign Data", e);
                        }
                      }}
                    />
                  ))
                ) : (
                  <div className="error-message">No Campaign Found</div>
                )}
              </div>
            </Scrollbars>
          </div>
        </div>

        {/*right side*/}
        <div className={"col-5 advertisement-right-side-wrapper"}>
          <CreateNewAdvertisement
            setRefresh={onChangeRefresh}
            doneRefresh={isLoading}
          />
        </div>
      </div>
    </>
  );
};
export default withRouter(Advertisement);
